export async function userDownloadCredentialsUseCase(data, userRepository) {
    const result = await userRepository.donwload_credentials(data);

    const entity = new userRepository.model_credentials(result.data.success.arguments.user);
    
    if (!entity.isValid()) {
        throw new Error("Credenciales de usuario no validas");
    }

    return result;
}